import { render, staticRenderFns } from "./chargeDetail.vue?vue&type=template&id=60c431f8&scoped=true&"
import script from "./chargeDetail.vue?vue&type=script&lang=js&"
export * from "./chargeDetail.vue?vue&type=script&lang=js&"
import style0 from "./chargeDetail.vue?vue&type=style&index=0&id=60c431f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c431f8",
  null
  
)

export default component.exports